import { TicketDetails } from "features/types";

export const isTicketReservedByGuestComponent = (ticket: TicketDetails) => {
  return (
    ticket.planPackageComponentType?.includes("GUEST") &&
    ticket.transferability !== "NONE"
  );
};

export const flightClubPlanIds = [
  1134, 1135, 1142, 1143, 1144, 1145, 1146, 1147,
];
